import { render } from "./avatar.vue?vue&type=template&id=4d297125&scoped=true&ts=true"
import script from "./avatar.vue?vue&type=script&lang=ts"
export * from "./avatar.vue?vue&type=script&lang=ts"

import "./avatar.vue?vue&type=style&index=0&id=4d297125&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d297125"]])

export default __exports__